<template>
  <!-- <el-amap
    class="amap-box"
    :events="events"
    :zoom="zoom"
    :center="center"
    vid="map"
  >
    <el-amap-marker
      v-for="marker in markers"
      :position="marker.position"
      :key="marker.id"
      :icon="marker.icon"
      :events="marker.events"
      vid="marker"
    ></el-amap-marker>
    <el-amap-text
      v-for="(item, index) in markers"
      :key="index"
      :text="item.devName"
      :position="item.position"
      :offset="offset"
      :events="item.event"
    ></el-amap-text>
    <el-amap-info-window
      v-for="marker in markers"
      :key="marker.ids"
      :ref="marker.ids"
      :position="marker.position"
      :isCustom="true"
      :visible="marker.visible"
      :content="marker.content"
      :events="marker.window_events"
      :closeWhenClickMap="true"
    ></el-amap-info-window>
  </el-amap> -->
  <el-amap
    class="amap-box"
    :events="events"
    :zoom="zoom"
    :center="center"
    vid="map"
    ref="map_ser"
  >
    <el-amap-marker
      v-for="marker in markers"
      :position="marker.position"
      :key="marker.id"
      :icon="marker.icon"
      :events="marker.events"
      vid="marker"
    ></el-amap-marker>
    <el-amap-text
      v-for="(item, index) in markers"
      :key="index"
      :text="item.devName"
      :position="item.position"
      :offset="offset"
      :events="item.event"
    ></el-amap-text>
    <el-amap-info-window
      v-for="marker in markers"
      :key="marker.ids"
      :ref="marker.ids"
      :position="marker.position"
      :isCustom="true"
      :visible="marker.visible"
      :content="marker.content"
      :events="marker.window_events"
      :closeWhenClickMap="true"
    ></el-amap-info-window>
  </el-amap>
</template>

<script>
import bar1 from '@/assets/images/di1.png'
import bar2 from '@/assets/images/di2.png'
import bar3 from '@/assets/images/di3.png'
import setting from '@/locales/lang/zh-CN/setting'
const self = this
export default {
  name: 'MapG',
  props: {
    width: {
      type: String || Number,
      default: '100%'
    },
    height: {
      type: String || Number,
      default: '100%'
    }
  },
  data () {
    return {
      showPoint: true,
      showMarker: false,
      map: null,
      zoom: 9,
      center: [113.27, 23.13],
      markers: [],
      points: [],
      infoWindow: null,
      clickTimer: null, // 定时器
      clickCount: 0, // 点击次数
      events: {
        init (map) {
          console.log(map, 'mapmapmapmap==================')
          this.map = map
          map.setMapStyle('amap://styles/352c0d35426816fd4fbd6547dba6d4e9')
          setTimeout(() => {
            const opts = {
              subdistrict: 0, // 获取边界不需要返回下级行政区
              extensions: 'all', // 返回行政区边界坐标组等具体信息
              level: 'city' // 查询行政级别为 市
            }
            const district = new AMap.DistrictSearch(opts)
            let polygons = []
            district.setLevel('广东省')
            district.search('广东省', (status, result) => {
              map.remove(polygons)// 清除上次结果
              polygons = []
              const bounds = result.districtList[0].boundaries
              if (bounds) {
                for (let i = 0, l = bounds.length; i < l; i++) {
                  // 生成行政区划polygon
                  const polygon = new AMap.Polygon({
                    strokeWeight: 1,
                    path: bounds[i],
                    fillOpacity: 0.5,
                    fillColor: '#14449c',
                    strokeColor: '#14449c'
                  })
                  polygons.push(polygon)
                }
              }
              map.add(polygons)
              map.setFitView(polygons)// 视口自适应
              const outer = [
                new AMap.LngLat(-360, 90, true),
                new AMap.LngLat(-360, -90, true),
                new AMap.LngLat(360, -90, true),
                new AMap.LngLat(360, 90, true)
              ]
              const holes = result.districtList[0].boundaries

              const pathArray = [
                outer
              ]
              pathArray.push.apply(pathArray, holes)
              const polygon = new AMap.Polygon({
                pathL: pathArray,
                // 线条颜色，使用16进制颜色代码赋值。默认值为#006600
                // strokeColor: 'rgb(20,164,173)',
                strokeColor: '#001826',
                strokeWeight: 1,
                // 轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                strokeOpacity: 0.5,
                // 多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
                fillColor: '#191919',
                // 多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                fillOpacity: 0.4,
                // 轮廓线样式，实线:solid，虚线:dashed
                strokeStyle: 'dashed',
                /* 勾勒形状轮廓的虚线和间隙的样式，此属性在strokeStyle 为dashed 时有效， 此属性在
                  ie9+浏览器有效 取值：
                  实线：[0,0,0]
                  虚线：[10,10] ，[10,10] 表示10个像素的实线和10个像素的空白（如此反复）组成的虚线
                  点画线：[10,2,10]， [10,2,10] 表示10个像素的实线和2个像素的空白 + 10个像素的实
                  线和10个像素的空白 （如此反复）组成的虚线 */
                strokeDasharray: [10, 2, 10]
              })
              polygon.setPath(pathArray)
              map.add(polygon)
            })
          }, 200)
        }
      },
      renderMarker: (context) => {
        // console.log('==context==', context)
        context.marker.setContent(context.data[0].content)
        context.marker.setIcon(context.data[0].icon)
      }
    }
  },
  methods: {
    clickPoint (e) {
      console.log('点击居合点', e)
      if (e.clusterData.length === 1) {
        this.$emit('clickMarker', e.clusterData[0])
      }
    },
    clickMarker (marker) {
      console.log('点击mark点', marker)
    },
    // 初始化mark点
    init (data) {
      const that = this
      console.log('地图设备', data)
      // console.log('地图>>>>>>>>>>>', this.$refs.map_ser)
      // console.log('地图>>>>>>>>>>>', this.$refs.map_ser.$$getInstance())
      if (this.$refs.map_ser) {
        this.map = this.$refs.map_ser.$$getInstance()
      }
      if (data.length > 0) {
        this.markers = []
        this.points = []
        data.forEach((item, index) => {
          if (!item.deviceLatitude) return
          const position = [item.deviceLongitude, item.deviceLatitude]
          let icon
          if (item.deviceStatus === 0) {
            icon = bar3
          } else if (item.devStatus === 1) {
            icon = bar1
          } else {
            icon = bar2
          }
          // var markerContent = '' +
          //   `<div class="marker-info">
          //     <span class="marker-info-text">${item.name}</span>
          //     <img class="marker-info-img" src="${icon}">
          //   </div>`
          var markerContent = '' +
            `<div class="marker-info">
              <img class="marker-info-img" src="${icon}">
            </div>`
          item.ids = index + 'map'
          item.content = '<div class="nesyds">'
          // item.content += '<img  class="images" onclick="amap_aaa.handleCose(' + 1 + ')" src="' + guan + '"' + ' > '
          item.content += '<div  id="devCon">'
          item.content += '<div class="textCent">设备名称<span>' + item.deviceName + '</span></div>'
          item.content += '<div class="textCent">设备编号<span>' + item.deviceCode + '</span></div>'
          item.content += '<div class="textCent">设备状态<span>' + (item.deviceStatus == 0 ? '离线 ' : item.deviceStatus == 1 ? '在线' : '故障') + '</span></div>'
          item.content += '<div class="textCent">设备地址<span>' + item.locationDescription + '</span></div>'
          item.content += '</div>'

          item.info = []
          item.info.push(`<div id='content_window_btn_${item.deviceCode}' class='input-card content-window-card'><div><h4>${item.deviceName}</h4></div>`)
          item.info.push(`<div style="padding:7px 0px 0px 0px;"><h4>序列号：${item.deviceCode}</h4>`)
          item.info.push(`<div style="padding:7px 0px 0px 0px;"><h4>定位地址：<a id='content_title_btn_${item.deviceCode}' @click="openAmapNavigation(item)" v-if="${item.formattedAddress}" title="${item.formattedAddress}">${item.formattedAddress || '-'}</a></h4>`)
          item.events = {
            // dblclick: (v) => {
            //   console.log('双击', v)
            //   that.mDblclick(item)
            // },
            // 鼠标右击事件
            rightclick: (v) => {
              that.mDataClick(item)
            },
            // 通过定时器和点击次数来区分单击和双击事件
            click: (v) => {
              that.clickCount++

              // 第一次点击：延迟执行单击
              // if (that.clickCount === 1) {
              //   that.clickTimer = setTimeout(() => {
              //     // 超时后判定为单击
              //     console.log('触发单击')
              //     that.mClick(item)
              //     that.clickCount = 0 // 重置
              //   }, 500) // 500ms 超时， 内没有第二次点击 = 单击
              // }

              // 第二次点击：判定为双击，清除单击定时器
              if (that.clickCount === 1) {
                clearTimeout(that.clickTimer) // 取消单击
                // console.log('触发双击')
                that.mDblclick(item)
                that.clickCount = 0 // 重置
              }
            },
            mouseover: (v) => {
              that.mMouseover(item)
            }
            // mouseout: (v) => {
            //   if (that.infoWindow) {
            //     that.infoWindow.close()
            //     that.infoWindow = null
            //   }
            // }
          }
          item.visible = false
          item.position = [Number(position[0]), Number(position[1])]
          this.markers.push(item)
          // console.log(this.markers, 'this.markersthis.markersthis.markers ')

          // this.markers.push({
          //   icon: icon,
          //   position: [Number(position[0]), Number(position[1])],
          //   content: item.content,
          //   // deviceName: item.deviceName,
          //   // deviceStatus: item.deviceStatus,
          //   // locationDescription: item.locationDescription,
          //   // deviceCode: item.deviceCode,
          //   visible: false,
          //   events: {
          //     click: () => {
          //       that.mClick(item)
          //     }
          //   },
          //   window_events: {
          //     close: () => {
          //       item.visible = false
          //       that.$forceUpdate()
          //     }
          //   }
          // })
          // console.log(that.markers, 'this.markers')
          that.points.push({ 'lnglat': [Number(position[0]), Number(position[1])], icon: icon, sn: item.sn, content: markerContent })
        })
      } else {
        this.points = []
        this.markers = []
      }
    },
    /**
     * @desc 设置mark点到地图中心并显示信息窗
     * @param {  }
     * @version: 1.0.0
     */
    toMapCenter (item) {
      // console.log(item, 'toMapCentertoMapCentertoMapCenter')
      if (this.map && item.deviceLongitude && item.deviceLatitude) {
        this.map.setZoomAndCenter(17, [item.deviceLongitude, item.deviceLatitude])
        // 3. 找到目标marker并更换图标
        const targetMarker = this.markers.find(marker => {
          // 匹配唯一标识（优先用deviceCode）
          return marker.deviceCode === item.deviceCode
        })
        if (targetMarker) {
          this.openInfo(targetMarker)
        }
      }
    },
    // 绘制遮罩，显示某个省
    drawBounds (map) {
      console.log(map, '大大大大大')
      // 加载行政区划插件
      const opts = {
        subdistrict: 0, // 获取边界不需要返回下级行政区
        extensions: 'all', // 返回行政区边界坐标组等具体信息
        level: 'city' // 查询行政级别为 市
      }
      const district = new AMap.DistrictSearch(opts)
      let polygons = []
      district.setLevel('湖南省')
      district.search('湖南省', (status, result) => {
        map.remove(polygons)// 清除上次结果
        polygons = []
        const bounds = result.districtList[0].boundaries
        if (bounds) {
          for (let i = 0, l = bounds.length; i < l; i++) {
            // 生成行政区划polygon
            const polygon = new AMap.Polygon({
              strokeWeight: 1,
              path: bounds[i],
              fillOpacity: 0.4,
              fillColor: '#ffffff',
              strokeColor: '#0A1A29'
            })
            polygons.push(polygon)
          }
        }
        map.add(polygons)
        map.setFitView(polygons)// 视口自适应
        const outer = [
          new AMap.LngLat(-360, 90, true),
          new AMap.LngLat(-360, -90, true),
          new AMap.LngLat(360, -90, true),
          new AMap.LngLat(360, 90, true)
        ]
        const holes = result.districtList[0].boundaries

        const pathArray = [
          outer
        ]
        pathArray.push.apply(pathArray, holes)
        const polygon = new AMap.Polygon({
          pathL: pathArray,
          // 线条颜色，使用16进制颜色代码赋值。默认值为#006600
          // strokeColor: 'rgb(20,164,173)',
          strokeColor: '#001826',
          strokeWeight: 1,
          // 轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
          strokeOpacity: 0.5,
          // 多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
          fillColor: '#ffffff',
          // 多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
          fillOpacity: 1,
          // 轮廓线样式，实线:solid，虚线:dashed
          strokeStyle: 'dashed',
          /* 勾勒形状轮廓的虚线和间隙的样式，此属性在strokeStyle 为dashed 时有效， 此属性在
            ie9+浏览器有效 取值：
            实线：[0,0,0]
            虚线：[10,10] ，[10,10] 表示10个像素的实线和10个像素的空白（如此反复）组成的虚线
            点画线：[10,2,10]， [10,2,10] 表示10个像素的实线和2个像素的空白 + 10个像素的实
            线和10个像素的空白 （如此反复）组成的虚线 */
          strokeDasharray: [10, 2, 10]
        })
        polygon.setPath(pathArray)
        map.add(polygon)
      })
    },
    mClick (item) {
      this.openAmapNavigation(item)
      item.visible = true
    },
    mMouseover (item) {
      console.log(item)
      this.openInfo(item)
    },
    mDblclick (item) {
      console.log('双击事件', item)
      if (item.deviceCategorizeCode != null) {
        if (item.deviceCategorizeCode === 'yin_protection_pile') {
          this.$router.push({ name: 'Device', params: { deviceCode: item.deviceCode } })
        } else if (item.deviceCategorizeCode === 'electric_drainage') {
          this.$router.push({ name: 'Electric_drainage', params: { deviceCode: item.deviceCode } })
        } else if (item.deviceCategorizeCode === 'recorder') {
          this.$router.push({ name: 'Recorder', params: { deviceCode: item.deviceCode } })
        }
      }
    },
    mDataClick (item) {
      if (item.deviceCategorizeCode != null) {
        if (item.deviceCategorizeCode === 'yin_protection_pile') {
          this.$router.push({ path: '/saifuneng/data/saifuneng/devicedata', query: { deviceId: item.deviceId } })
        } else if (item.deviceCategorizeCode === 'electric_drainage') {
          this.$router.push({ path: '/saifuneng/data/saifuneng/devicedata/electric_drainage', query: { deviceId: item.deviceId } })
        } else if (item.deviceCategorizeCode === 'recorder') {
          this.$router.push({ path: '/saifuneng/data/saifuneng/devicedata/recorder', query: { deviceId: item.deviceId } })
        }
      }
    },
    openInfo(item) {
      if (this.infoWindow) {
        this.infoWindow.close()
        this.infoWindow = null
      }
      // 构建信息窗体中显示的内容
      this.infoWindow = new AMap.InfoWindow({
        content: item.info.join(''), // 使用默认信息窗体框样式，显示信息内容
        offset: new AMap.Pixel(0, -30)
      })
      // console.log('>>>>>>>>>>>', this.map)
      setTimeout(() => { // 延迟确保DOM已渲染
        // console.log('>>>>>>>>>>>>', document.getElementById('content_title_btn_' + item.deviceCode))

        const btn = document.getElementById('content_title_btn_' + item.deviceCode)
        if (btn) {
          btn.addEventListener('click', () => {
            console.log('打开高德导航')
            // 业务逻辑...
            this.openAmapNavigation(item)
          })
        }

        const infoWindowClose = document.getElementById('content_window_btn_' + item.deviceCode)
        if (infoWindowClose) {
          infoWindowClose.addEventListener('mouseleave', (e) => {
            // console.log('关闭信息弹窗')
            // if (e.relatedTarget !== this && !this.contains(e.relatedTarget)) {
            //   console.log('鼠标已经移出父元素');
            //   // 在这里执行你的代码
            //   if (this.infoWindow) {
            //     this.infoWindow.close()
            //     this.infoWindow = null
            //   }
            // }
            // e.stopPropagation()
            // // 业务逻辑...
            if (this.infoWindow) {
              this.infoWindow.close()
              this.infoWindow = null
            }
          })
        }
      }, 100)
      this.infoWindow.open(this.map, [item.deviceLongitude, item.deviceLatitude])
    },
    /** 打开高德导航 */
    openAmapNavigation(record) {
      var fromLongitude = ''
      var fromLatitude = ''
      var fromPlaceName = ''
      this.getCurrentLocation().then(res => {
        fromLongitude = res.longitude
        fromLatitude = res.latitude
        var toLongitude = record.deviceLongitude
        var toLatitude = record.deviceLatitude
        var toPlaceName = record.locationDescription
        console.log('起点：' + fromLongitude + ',' + fromLatitude)
        console.log('终点：' + toLongitude + ',' + toLatitude)
        const url = `https://uri.amap.com/navigation?from=${fromLongitude},${fromLatitude},${encodeURIComponent(fromPlaceName)}&to=${toLongitude},${toLatitude},${encodeURIComponent(toPlaceName)}&mode=car&policy=0&callnative=1`
        window.open(url, '_blank')
      }).catch(err => {
        this.$message.warning(err)
      })
    },
    getCurrentLocation() {
      return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          reject(new Error('浏览器不支持定位功能'))
          return
        }
        navigator.geolocation.getCurrentPosition(
          // 成功回调
          (position) => {
            const location = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              accuracy: position.coords.accuracy,
              altitude: position.coords.altitude,
              altitudeAccuracy: position.coords.altitudeAccuracy,
              heading: position.coords.heading,
              speed: position.coords.speed,
              timestamp: position.timestamp
            }
            resolve(location)
          },
          // 失败回调
          (error) => {
            let errorMessage = ''
            switch (error.code) {
              case error.PERMISSION_DENIED:
                errorMessage = '用户拒绝定位请求'
                break
              case error.POSITION_UNAVAILABLE:
                errorMessage = '位置信息不可用'
                break
              case error.TIMEOUT:
                errorMessage = '定位请求超时'
                break
              case error.UNKNOWN_ERROR:
                errorMessage = '未知错误'
                break
            }
            reject(errorMessage)
          },
          // 可选配置
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0
          }
        )
      })
    },
    clickArrayMarker (item, e) {
      console.log('点击mark点', item)
      this.$emit('clickMarker', item)
    }
  }
}
</script>

<style lang="less">
.marker-info {
  position: relative;
  width: 200px;
  display: flex;
}

.marker-info-img {
  width: 35px !important;
  height: 41px !important;
}

.marker-info-text {
  width: 100%;
  position: absolute;
  top: -20px;
  left: -45%;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.nesyds {
  /* position: absolute !important; */
  background: rgba(13, 46, 100, 0.8) !important;
  width: 330px !important;
  height: 150px !important;
  border-radius: 7px;
  color: #fff !important;
  padding-top: 18px;
  padding-right: 16px;
  overflow-y: auto;

  /* padding-top: 20px !important; */
  /* top: 0 !important;
  left: 0 !important; */
  .images {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  #devDel {
    color: #00F6FF;
  }

  .tab {
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.49);
    font-size: 16px;
    padding-left: 21px;

    div {
      margin-right: 27px;
      cursor: pointer;
    }
  }

  .textCent {
    padding-left: 21px;
    // margin-bottom: 15px;
    font-size: 12px;
    padding-top: 8px;
    display: flex;
    justify-content: space-between;
    align-content: center;
    // overflow: hidden !important;
    width: 100%;
    // width: 200px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // text-align: left;
    // background: red !important;
  }
}
</style>
